module.exports = __webpack_public_path__ + "static/media/terraspeak-4.c181fe51.jpg";